import "./DataList.css";
import ButtonPages from "../ButtonPages/ButtonPages";
import { usePermissao } from "../../app/hooks/UsePermissao";

import { getSecaoFromTab } from "../../util/tabUtils";
import { Button, Box, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function DataList({ title, datas = [], totalCount, tab, paginaAtual, setPaginaAtual, itensPorPagina = 20, onEdit, onDelete }) {
  const { temPermissao } = usePermissao();

  return (
    <div className="data-list-card">
      <div className="data-list-title">{title}</div>
      <div className="data-list-container">

        {(datas || [])
          .map((p) => {
            const secao = getSecaoFromTab(tab);

            return (
              <div key={p.id || p.nome} className="data-list-row">
                <div className="data-name">
                  {tab === "trem"
                    ? `${p.nome} - ${p.quantidadeCarros} carros`
                    : tab === "usuario"
                      ? `${p.email}`
                      : p.nome}
                </div>
                <div className="data-actions">
                   {temPermissao("Cadastro.Editar") && <Button
                    className="icon"
                    title={"Editar"}
                    onClick={() => onEdit && onEdit(tab, p)}
                    
                  >
                    <EditIcon sx={{ color: "#5E22F3" }} />
                  </Button>}
                  
                   {temPermissao("Cadastro.Excluir") &&  <Button
                    className="icon"
                    title="Excluir"
                    onClick={() => onDelete && onDelete(p.id, tab === "usuario" ? p.email : p.nome, paginaAtual)}
                  >
                    <DeleteOutlineIcon sx={{ color: "red" }} />
                  </Button>}
                </div>
              </div>
            );
          })}
        {datas.length === 0 && (
          <div className="data-empty">Não há {title.split(" ")[0].toLowerCase()} cadastrados.</div>
        )}

        <ButtonPages
          paginaAtual={paginaAtual}
          setPaginaAtual={setPaginaAtual}
          totalCount={totalCount}
          itensPorPagina={itensPorPagina}
        />
      </div>
    </div>
  );
}
